import React from 'react'

const RefundStep = () => {
  return <div>RefundStep</div>
}

export default RefundStep

export const isRefundStepValid = (corrInfo) => {
  return true
}
